export default __webpack_public_path__ + "static/media/more-icon-filled.1236c380.svg";